import { IconButton, Stack, Tooltip } from "@mui/material";
import { type BaseSyntheticEvent, type MouseEvent, useState } from "react";
import BadgeDetached from "@entrilia/shared/components/BadgeDetached";
import ItemsListPopover from "@entrilia/shared/components/ItemsListPopover";
import TypographyTooltipEllipsis from "@entrilia/shared/components/TypographyTooltipEllipsis";
import PdfIcon from "@entrilia/shared/icons/fileFormats/PdfIcon";

interface Props {
  fileNames: string;
  transactionNo: string;
  onOpenDialog: (transactionNo: string) => void;
}

const FILE_NAMES_DELIMITER = ";;";

const DrillDownAttachedFilesIcon = ({ fileNames, transactionNo, onOpenDialog }: Props) => {
  const [popoverAnchor, setPopoverAnchor] = useState<HTMLElement | undefined>();
  const files = fileNames.split(FILE_NAMES_DELIMITER);
  const count = files.length;

  const handleIconClick = (event: MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    onOpenDialog(transactionNo);
  };

  const handleBadgeClick = (event: MouseEvent<HTMLElement>) => {
    event.preventDefault();
    event.stopPropagation();
    setPopoverAnchor((prev) => (prev ? undefined : event.currentTarget));
  };

  const closePopover = (event: BaseSyntheticEvent) => {
    event.stopPropagation();
    setPopoverAnchor(undefined);
  };

  return (
    <Stack
      direction="row"
      onClick={(event) => event.stopPropagation()}
      onMouseDown={(event) => event.stopPropagation()}
      sx={{ alignItems: "center", gap: 0.5 }}
    >
      <Tooltip title="View all attached files" disableInteractive>
        <IconButton size="small" onClick={handleIconClick}>
          <PdfIcon />
        </IconButton>
      </Tooltip>
      {count > 1 && (
        <BadgeDetached
          color="secondary"
          badgeContent={`+${count - 1}`}
          onClick={handleBadgeClick}
          sx={{ cursor: "pointer" }}
        />
      )}
      <ItemsListPopover anchorEl={popoverAnchor} onClose={closePopover}>
        {files.map((name, i) => (
          <TypographyTooltipEllipsis
            // eslint-disable-next-line @eslint-react/no-array-index-key
            key={i}
            text={name}
            typographyProps={{ sx: { maxWidth: 300 } }}
            tooltipProps={{ disableInteractive: true }}
          />
        ))}
      </ItemsListPopover>
    </Stack>
  );
};

export default DrillDownAttachedFilesIcon;
